const AddressCreateFormatter = (data, defaultFormData) => {
  const dataSet = data?.data || data;
  const formData = JSON.parse(JSON.stringify(defaultFormData));
  dataSet["customer_id"] = formData["customer_id"];
  return dataSet;
};

export default AddressCreateFormatter;
